// extracted by css-extract-rspack-plugin
export default {"row":"b0ZRh"};